import { render, staticRenderFns } from "./IntegerField.vue?vue&type=template&id=9644b0fe&scoped=true"
import script from "./IntegerField.vue?vue&type=script&lang=js"
export * from "./IntegerField.vue?vue&type=script&lang=js"
import style0 from "./IntegerField.vue?vue&type=style&index=0&id=9644b0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9644b0fe",
  null
  
)

export default component.exports